import { render, staticRenderFns } from "./scenery-box-song.vue?vue&type=template&id=77a8ddd9&scoped=true&"
import script from "./scenery-box-song.vue?vue&type=script&lang=js&"
export * from "./scenery-box-song.vue?vue&type=script&lang=js&"
import style0 from "./scenery-box-song.vue?vue&type=style&index=0&id=77a8ddd9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8ddd9",
  null
  
)

export default component.exports